__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "moodboard";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@emotion/react", "11.14.0", () => (() => (__webpack_require__(2608))), 1);
			register("@mui/material", "6.5.0", () => (() => (__webpack_require__(8920))), 1);
			register("@reduxjs/toolkit", "2.10.1", () => (() => (__webpack_require__(8901))), 1);
			register("i18next", "25.6.2", () => (() => (__webpack_require__(6532))), 1);
			register("lodash", "4.17.21", () => (() => (__webpack_require__(1878))), 1);
			register("react-dom", "18.3.1", () => (() => (__webpack_require__(2836))), 1);
			register("react-i18next", "15.7.4", () => (() => (__webpack_require__(8706))), 1);
			register("react-redux", "9.2.0", () => (() => (__webpack_require__(3594))), 1);
			register("react-router-dom", "7.9.6", () => (() => (__webpack_require__(7044))), 1);
			register("react", "18.3.1", () => (() => (__webpack_require__(483))), 1);
			initExternal(2261);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};